import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StickyButtonArea } from './style';

const StickyPostButton = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <StickyButtonArea className={visible ? 'visible' : ''}>
      <Link to="/post-an-add" className="sticky-btn">
        <i className="fas fa-plus-circle"></i>
        <span>{t('postAd')}</span>
      </Link>
    </StickyButtonArea>
  );
};

export default StickyPostButton;
